<template>
  <v-stepper :items="titles" flat ref="stepper">
    <template
      v-for="(title, index) in titles"
      :key="`content${index + 1}`"
      v-slot:[`item.${index+1}`]
    >
      <slot :name="`content(${index + 1})`" :prev="prev" :next="next"></slot>
    </template>
    <!--    actionsは各画面独自実装なので、不要-->
    <template v-slot:actions></template>
  </v-stepper>
</template>
<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppStepper",
  props: {
    /** タイトル一覧 */
    titles: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    prev() {
      (this.$refs.stepper as { prev: () => void }).prev();
    },
    next() {
      (this.$refs.stepper as { next: () => void }).next();
    },
  },
});
</script>
